/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import React from "react";
import Grid from "@mui/material/Grid";
import { formValue } from "../../../services/formServiceFunctions";
import useForm from "../../../hooks/useForm";
import ValidatorForm from "../../Validator/ValidatorForm";
import ValidatorSelect from "../../Validator/ValidatorSelect";
import MenuItem from "@mui/material/MenuItem";
import SubmitButton from "../../Button/SubmitButton";
import _ from "lodash";
import ValidatorNumberField from "../../Validator/ValidatorNumberField";
import { Box } from "@mui/material";
import { processCostSupportStyle } from "../processCostSupportStyle";
import { ProcessCostSupportFormProps } from "../../../types/ProcessCostSupport";

const OtherInsuranceDeduction = ({ pcs, onSubmit, isLoading }: ProcessCostSupportFormProps) => {
  const initialValues = {
    hasOtherInsuranceDeduction: pcs.hasOtherInsuranceDeduction,
    otherInsuranceAmount: pcs.otherInsuranceAmount,
  };

  const { values, errors, handleChange, handleSubmit, handleBlur, registerValidators, touchedValues } = useForm({
    initialValues,
    onSubmit,
    identifier: pcs,
  });
  return (
    <>
      <Box sx={processCostSupportStyle.sectionHeadline}>Kosten durch Versicherungen</Box>
      <ValidatorForm onSubmit={handleSubmit}>
        <Grid container sx={processCostSupportStyle.grid}>
          <Grid sx={processCostSupportStyle.question} size={12}>
            Haben Sie Kosten durch Versicherungen, wie zum Beispiel Haftpflicht-, Hausrat-, oder private
            Krankenversicherung?
          </Grid>
          <Grid
            size={{
              xs: 12,
              md: 6,
              lg: 4
            }}>
            <ValidatorSelect
              label={"Kosten"}
              name={"hasOtherInsuranceDeduction"}
              value={formValue(values, "hasOtherInsuranceDeduction")}
              onChange={handleChange}
              onBlur={handleBlur}
              registerValidators={registerValidators}
              dependentValidationFields={["otherInsuranceAmount"]}
            >
              <MenuItem value={"no"}>Nein</MenuItem>
              <MenuItem value={"yes"}>Ja</MenuItem>
            </ValidatorSelect>
          </Grid>
          <Grid
            size={{
              xs: 12,
              md: 6,
              lg: 4
            }}>
            <ValidatorNumberField
              fieldType={"money"}
              numberType={"float"}
              fullWidth={true}
              id="otherInsuranceAmount"
              name="otherInsuranceAmount"
              label="Mtl. Kosten"
              onBlur={handleBlur}
              isHighlighted={formValue(values, "hasOtherInsuranceDeduction") === "yes"}
              registerValidators={registerValidators}
              error={!!errors["otherInsuranceAmount"]}
              helperText={errors["otherInsuranceAmount"]}
              margin="normal"
              value={formValue(values, "otherInsuranceAmount")}
              onChange={handleChange}
              disabled={formValue(values, "hasOtherInsuranceDeduction") !== "yes"}
            />
            Bitte fassen Sie diese zu einem monatlichen Betrag zusammen.
          </Grid>
          <Grid size={12}>
            <SubmitButton
              error={_.keys(errors).length > 0}
              isLoading={isLoading}
              disabled={_.keys(touchedValues).length === 0}
              variant={"contained"}
              type={"submit"}
            >
              Änderungen speichern
            </SubmitButton>
          </Grid>
        </Grid>
      </ValidatorForm>
    </>
  );
};

export default OtherInsuranceDeduction;
